/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LocationVo } from './LocationVo';
import {
    LocationVoFromJSON,
    LocationVoFromJSONTyped,
    LocationVoToJSON,
    LocationVoToJSONTyped,
} from './LocationVo';

/**
 * 
 * @export
 * @interface BatchVo
 */
export interface BatchVo {
    /**
     * 商品批次 goodsId
     * @type {number}
     * @memberof BatchVo
     */
    goodsId?: number;
    /**
     * 批次号（库存订单编号）
     * @type {string}
     * @memberof BatchVo
     */
    batchNo?: string;
    /**
     * 库存订单编号
     * @type {string}
     * @memberof BatchVo
     */
    orderCode?: string;
    /**
     * 批次可用库存
     * @type {number}
     * @memberof BatchVo
     */
    availableQty?: number;
    /**
     * 批次下货位可用量
     * @type {Array<LocationVo>}
     * @memberof BatchVo
     */
    locations?: Array<LocationVo>;
}

/**
 * Check if a given object implements the BatchVo interface.
 */
export function instanceOfBatchVo(value: object): value is BatchVo {
    return true;
}

export function BatchVoFromJSON(json: any): BatchVo {
    return BatchVoFromJSONTyped(json, false);
}

export function BatchVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'batchNo': json['batchNo'] == null ? undefined : json['batchNo'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'availableQty': json['availableQty'] == null ? undefined : json['availableQty'],
        'locations': json['locations'] == null ? undefined : ((json['locations'] as Array<any>).map(LocationVoFromJSON)),
    };
}

export function BatchVoToJSON(json: any): BatchVo {
    return BatchVoToJSONTyped(json, false);
}

export function BatchVoToJSONTyped(value?: BatchVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'batchNo': value['batchNo'],
        'orderCode': value['orderCode'],
        'availableQty': value['availableQty'],
        'locations': value['locations'] == null ? undefined : ((value['locations'] as Array<any>).map(LocationVoToJSON)),
    };
}

